import Renderer from 'apollo-e/rendering/Renderer';
import Object3D from 'apollo-e/rendering/Object3D';
import Mesh3D_TRIANGLE_normal_uv from 'apollo-e/meshes/Mesh3D_TRIANGLE_normal_uv';
import { Shader, VertexShader, FragmentShader, ShaderProgram } from 'apollo-e/rendering/Shader';
import QuadGeometry from 'apollo-e/geometries/QuadGeometry';

import opacities from 'apollo-e/rendering/OPACITIES';

const defaultVertexScript = require('./shaders/vertex/copy.vert');
const defaultFragmentScript = require('./shaders/fragment/copyOutlined.frag');

// const depthVertexScript = require('./shaders/vertex/qtaDepth.vert');
// const depthFragmentScript = require('./shaders/fragment/qtaDepth.frag');

// const shadedVertexScript = require('./shaders/vertex/copyShaded.vert');
// const shadedFragmentScript = require('./shaders/fragment/copyOutlined.frag');

const defaultVertexShader = new VertexShader(defaultVertexScript, ['aVertexPosition', 'aUV'], ['uMMatrix']);
const defaultFragmentShader = new FragmentShader(defaultFragmentScript, ['uGreyScale'], ['uTexture']);
const defaultShader = new Shader(defaultVertexShader, defaultFragmentShader);

// const depthVertexShader = new VertexShader(depthVertexScript, ['aVertexPosition', 'aUV'], ['uMMatrix']);
// const depthFragmentShader = new FragmentShader(depthFragmentScript, [], ['uTexture']);
// const depthShader = new Shader(depthVertexShader, depthFragmentShader);

// const shadedVertexShader = new VertexShader(shadedVertexScript, ['aVertexPosition', 'aUV'], ['uMMatrix', 'uShadowMapVPMatrix']);
// const shadedFragmentShader = new FragmentShader(shadedFragmentScript, [], ['uTexture', 'uShadowMap']);
// const shadedShader = new Shader(shadedVertexShader, shadedFragmentShader);

const shaders = {
	default: defaultShader,
	// depth: depthShader,
	// shaded: shadedShader
};

const quadMesh = new Mesh3D_TRIANGLE_normal_uv(new QuadGeometry());

export default class CopyOutlined extends Object3D {
	mesh: Mesh3D_TRIANGLE_normal_uv;
	greyScale: number;

	shaders = shaders;

	constructor () {
		super();

		this.opacity = opacities.TRANSLUSCENT;
		this.mesh = quadMesh;
		this.greyScale = 0;
	}

	renderDefault (renderer: Renderer, program: ShaderProgram) {
		const gl = renderer.gl;
		const uniforms = program.uniforms;
		gl.uniform1f(uniforms.uGreyScale, this.greyScale);
		this.mesh.render(renderer, program, false);
	}

	// renderDepth (renderer: Renderer, program: ShaderProgram) {
	// 	this.mesh.render(renderer, program, false);
	// }

	// renderShaded = this.renderDefault

}
